import {Outlet,Navigate} from "react-router-dom";
import Cookies from 'js-cookie'
export const PublicRoutes = () => {
let token=Cookies.get(`${process.env.NODE_ENV}-userToken`);   
 if(!token){
    return <Outlet/>
}
else{
    return (<>
    <Navigate to="/dashboard"/>
    </>)
    
}
;
}
